import config from '../../../config';

const baseUrl = `${config.apiUrl(1)}/FineSyncConfiguration`;

export default {
  get: (): string => `${baseUrl}`,
  update: (): string => `${baseUrl}`,
};
